module.exports = __webpack_public_path__ + "static/media/89.7ee2285f.jpg";